import React from "react";
import { Outlet } from "react-router-dom";
import AppFooter from "../shared-layout/AppFooter";

const GuestLayout: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <main
        className="
          min-h-[calc(100vh-3.5rem)]
        bg-primary-50
          grid place-items-center
          min-w-0"
      >
        <Outlet />
      </main>

      {/* Slim footer for guest pages */}
      <AppFooter minimal className="h-14" />
      {/* If you don't want to use`minimal`, you can do:
          <AppFooter minimal className="text-xs py-3" forceModal />
      */}
    </div>
  );
};

export default GuestLayout;
